import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPages.css';

const PrivacyPage = () => {
    return (
        <div className="policy-page">
            <div className="policy-hero">
                <div className="container">
                    <h1>Privacy policy</h1>
                    <p>
                        How we collect, use, and protect your personal information.
                    </p>
                </div>
            </div>

            <div className="container policy-body">
                <article className="policy-prose">
                    <p className="lead">
                        Rahber Corporation respects your privacy. This policy explains
                        what we collect when you use our website or shop with us, and
                        your choices.
                    </p>

                    <h2>Information we collect</h2>
                    <ul>
                        <li>
                            <strong>Contact details:</strong> name, phone number, email,
                            delivery address, provided when you place an order, contact us, or
                            subscribe to updates.
                        </li>
                        <li>
                            <strong>Order data:</strong> products purchased, payment
                            method type (we do not store full card numbers on our
                            servers), and delivery history.
                        </li>
                        <li>
                            <strong>Technical data:</strong> browser type, IP address,
                            and cookies (see below) to improve site performance and
                            security.
                        </li>
                    </ul>

                    <h2>How we use your information</h2>
                    <ul>
                        <li>To process and deliver your orders.</li>
                        <li>
                            To communicate about your purchase, delivery, or support
                            requests.
                        </li>
                        <li>
                            To send promotional offers if you have opted in (you can
                            unsubscribe anytime).
                        </li>
                        <li>To comply with legal obligations and prevent fraud.</li>
                    </ul>

                    <h2>Sharing</h2>
                    <p>
                        We may share data with trusted partners who help us operate
                        (e.g. courier companies, payment processors, installment
                        partners) only as needed to fulfil your order. We do not sell
                        your personal data to third parties for their marketing.
                    </p>

                    <h2>Cookies</h2>
                    <p>
                        Our site may use cookies and similar technologies to remember
                        preferences and analyse traffic. You can control cookies through
                        your browser settings; disabling them may affect some features
                        (e.g. cart persistence on this device uses local storage in your
                        browser).
                    </p>

                    <h2>Data retention</h2>
                    <p>
                        We keep information only as long as needed for order fulfilment,
                        warranty, accounting, and legal requirements, typically a few
                        years for transaction records unless a longer period is
                        required by law.
                    </p>

                    <h2>Your rights</h2>
                    <p>
                        You may request access to, correction of, or deletion of your
                        personal data where applicable. Contact us using the details on
                        our <Link to="/contact">Contact</Link> page. We will respond
                        within a reasonable time.
                    </p>

                    <h2>Security</h2>
                    <p>
                        We use appropriate technical and organizational measures to
                        protect your data. No online transmission is 100% secure; please
                        use strong passwords and protect your devices.
                    </p>

                    <h2>Children</h2>
                    <p>
                        Our services are not directed at children under 13. We do not
                        knowingly collect data from children.
                    </p>

                    <h2>Updates</h2>
                    <p>
                        We may revise this policy. The “Last updated” date below will
                        change when we do. Continued use after updates means you accept
                        the revised policy.
                    </p>

                    <p>
                        Questions: <Link to="/contact">Contact us</Link> ·{' '}
                        <Link to="/terms">Terms of Service</Link>
                    </p>
                </article>
            </div>
        </div>
    );
};

export default PrivacyPage;
